import React, { useRef, useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import * as d3 from 'd3';
import { LucideIcon } from './ot.jsx';

// ── Graph data ─────────────────────────────────────────────────────────────────

const NODE_TYPE_META = {
  page:      { color: '#6366f1', glowColor: 'rgba(99,102,241,0.5)',  baseR: 13, labelColor: '#a5b4fc', badge: 'Indigo',  zh: 'Page'      },
  component: { color: '#3b82f6', glowColor: 'rgba(59,130,246,0.5)',  baseR: 10, labelColor: '#93c5fd', badge: 'Blue',    zh: 'Component' },
  library:   { color: '#a855f7', glowColor: 'rgba(168,85,247,0.5)',  baseR: 14, labelColor: '#d8b4fe', badge: 'Purple',  zh: 'Library'   },
  external:  { color: '#64748b', glowColor: 'rgba(100,116,139,0.4)', baseR: 8,  labelColor: '#94a3b8', badge: 'Default', zh: 'External'  },
};

const RAW_NODES = [
  // ── Pages ─────────────────────────────────────────────────────────────────
  { id: 'name_1',  label: 'Name1',  type: 'page', demo: '_1',  desc: '文件管理首頁',    file: 'name_1.jsx'  },
  { id: 'name_2',  label: 'Name2',  type: 'page', demo: '_2',  desc: '文件建立精靈',    file: 'name_2.jsx'  },
  { id: 'name_3',  label: 'Name3',  type: 'page', demo: '_3',  desc: 'Canvas 編輯器',   file: 'name_3.jsx'  },
  { id: 'name_4',  label: 'Name4',  type: 'page', demo: '_4',  desc: '回覆資料管理',    file: 'name_4.jsx'  },
  { id: 'name_6',  label: 'Name6',  type: 'page', demo: '_6',  desc: '資料夾結構管理',  file: 'name_6.jsx'  },
  { id: 'name_7',  label: 'Name7',  type: 'page', demo: '_7',  desc: '靜態表單預覽',    file: 'name_7.jsx'  },
  { id: 'name_8',  label: 'Name8',  type: 'page', demo: '_8',  desc: 'Canvas 回覆編輯', file: 'name_8.jsx'  },
  { id: 'name_9',  label: 'Name9',  type: 'page', demo: '_9',  desc: '表單測試結果',    file: 'name_9.jsx'  },
  { id: 'name_10', label: 'Name10', type: 'page', demo: '_10', desc: '金流整合管理',    file: 'name_10.jsx' },
  { id: 'name_11', label: 'Name11', type: 'page', demo: '_11', desc: '空間預約系統',    file: 'name_11.jsx' },
  { id: 'name_12', label: 'Name12', type: 'page', demo: '_12', desc: '通用 CRUD 列表',  file: 'name_12.jsx' },
  { id: 'name_13', label: 'Name13', type: 'page', demo: '_13', desc: '公告管理',        file: 'name_13.jsx' },
  { id: 'name_14', label: 'Name14', type: 'page', demo: '_14', desc: '系統設定管理',    file: 'name_14.jsx' },
  { id: 'name_15', label: 'Name15', type: 'page', demo: '_15', desc: '帳款管理',        file: 'name_15.jsx' },
  { id: 'name_16', label: 'Name16', type: 'page', demo: '_16', desc: '統計報表',        file: 'name_16.jsx' },
  { id: 'name_17', label: 'Name17', type: 'page', demo: '_17', desc: '排行比較',        file: 'name_17.jsx' },
  { id: 'name_18', label: 'Name18', type: 'page', demo: '_18', desc: '審批流程',        file: 'name_18.jsx' },
  { id: 'name_19', label: 'Name19', type: 'page', demo: '_19', desc: '簽核簽名',        file: 'name_19.jsx' },
  { id: 'name_20', label: 'Name20', type: 'page', demo: '_20', desc: '媒體庫管理',      file: 'name_20.jsx' },
  { id: 'name_21', label: 'Name21', type: 'page', demo: '_21', desc: '知識庫管理',      file: 'name_21.jsx' },
  { id: 'name_22', label: 'Name22', type: 'page', demo: '_22', desc: '排班管理',        file: 'name_22.jsx' },
  { id: 'name_23', label: 'Name23', type: 'page', demo: '_23', desc: '商品目錄',        file: 'name_23.jsx' },
  { id: 'name_24', label: 'Name24', type: 'page', demo: '_24', desc: '看板視圖',        file: 'name_24.jsx' },
  { id: 'name_25', label: 'Name25', type: 'page', demo: '_25', desc: '甘特圖時程',      file: 'name_25.jsx' },
  { id: 'name_26', label: 'Name26', type: 'page', demo: '_26', desc: '通知中心',        file: 'name_26.jsx' },
  { id: 'name_27', label: 'Name27', type: 'page', demo: '_27', desc: '申請單流程',      file: 'name_27.jsx' },
  { id: 'name_28', label: 'Name28', type: 'page', demo: '_28', desc: '月曆出勤視圖',    file: 'name_28.jsx' },
  { id: 'name_29', label: 'Name29', type: 'page', demo: '_29', desc: '成員管理',        file: 'name_29.jsx' },
  { id: 'name_30', label: 'Name30', type: 'page', demo: '_30', desc: '全文搜尋結果',    file: 'name_30.jsx' },
  { id: 'name_31', label: 'Name31', type: 'page', demo: '_31', desc: '資料匯入匯出',    file: 'name_31.jsx' },
  { id: 'name_32', label: 'Name32', type: 'page', demo: '_32', desc: '時間軸活動記錄',  file: 'name_32.jsx' },
  { id: 'name_33', label: 'Name33', type: 'page', demo: '_33', desc: 'QR 票券管理',     file: 'name_33.jsx' },
  { id: 'name_34', label: 'Name34', type: 'page', demo: '_34', desc: '成就徽章積分',    file: 'name_34.jsx' },
  { id: 'name_35', label: 'Name35', type: 'page', demo: '_35', desc: '自訂儀表板',      file: 'name_35.jsx' },
  { id: 'name_36', label: 'Name36', type: 'page', demo: '_36', desc: '打卡明細',        file: 'name_36.jsx' },
  // ── Libraries ──────────────────────────────────────────────────────────────
  { id: 'ot.jsx',   label: 'ot.jsx',   type: 'library',   desc: '多元件庫：Button、Modal、ProTableOt、useCRUDController 等 antd 封裝', file: 'ot.jsx'   },
  { id: 'card.jsx', label: 'card.jsx', type: 'component', desc: 'Card / CardContent / CardHeader / CardTitle',                         file: 'card.jsx' },
  // ── Components ─────────────────────────────────────────────────────────────
  { id: 'base_stats_card_header', label: 'BaseStatsCardHeader', type: 'component', desc: '統計卡片標頭（帶計數動畫）',      file: 'base_stats_card_header.jsx' },
  { id: 'base_card_view',         label: 'BaseCardView',         type: 'component', desc: '通用卡片視圖基底元件',            file: 'base_card_view.jsx'         },
  { id: 'base_list_view',         label: 'BaseListView',         type: 'component', desc: '通用列表視圖基底元件',            file: 'base_list_view.jsx'         },
  { id: 'base_canvas_edit_2',     label: 'BaseCanvasEdit2',      type: 'component', desc: '可拖放 Canvas 欄位編輯器 v2',    file: 'base_canvas_edit_2.jsx'     },
  { id: 'form_static_5',          label: 'FormStatic5',          type: 'component', desc: '靜態問卷表單渲染元件 v5',        file: 'form_static_5.jsx'          },
  { id: 'base_doc_cre_canvas',    label: 'BaseDocCRECanvasEdit', type: 'component', desc: '文件建立回覆 Canvas 編輯器',     file: 'base_document_create_response_canvas_edit.jsx' },
  { id: 'base_input_storage',     label: 'BaseInputStorage',     type: 'component', desc: '多模組資料夾 + 欄位輸入儲存',    file: 'base_input_storage.jsx'     },
  { id: 'base_calender',          label: 'BaseCalendar',         type: 'component', desc: '行事曆元件（空間預約用）',       file: 'base_calender.jsx'          },
  { id: 'payment_component',      label: 'PaymentComponent',     type: 'component', desc: 'ECPay 金流步驟與付款方式選擇',   file: 'payment_component.jsx'      },
  { id: 'crm_dashboard',          label: 'CrmDashboard',         type: 'component', desc: 'CRM 儀表板 + Modal',            file: 'crm_base/crm_dashboard.jsx' },
  { id: 'scroll_area',            label: 'ScrollArea',           type: 'component', desc: 'Radix UI 可捲動區域容器',        file: 'scroll-area.jsx'            },
  // ── External ───────────────────────────────────────────────────────────────
  { id: 'dayjs',            label: 'dayjs',            type: 'external', desc: '輕量日期處理套件',                               file: 'dayjs (npm)'            },
  { id: 'react_router_dom', label: 'react-router-dom', type: 'external', desc: 'SPA 路由管理套件',                               file: 'react-router-dom (npm)' },
  { id: 'dnd_kit',          label: '@dnd-kit',          type: 'external', desc: '拖曳排序套件（core + sortable + utilities）',     file: '@dnd-kit/* (npm)'       },
  { id: 'gantt_task_react', label: 'gantt-task-react', type: 'external', desc: 'React 甘特圖元件庫',                              file: 'gantt-task-react (npm)' },
];

const PAGE_IDS = [
  'name_1','name_2','name_3','name_4','name_6','name_7','name_8','name_9',
  'name_10','name_11','name_12','name_13','name_14','name_15','name_16','name_17',
  'name_18','name_19','name_20','name_21','name_22','name_23',
  'name_24','name_25','name_26','name_27','name_28','name_29','name_30',
  'name_31','name_32','name_33','name_34','name_35','name_36',
];

const RAW_LINKS = [
  // ── ot.jsx 引用 (每頁明確列出引用項目) ────────────────────────────────────────
  // name_6 / name_8 / name_9 未引用 ot.jsx，故不列入
  { source: 'name_1',  target: 'ot.jsx', imports: ['Row','Col','Button','jsonToQueryString','DeleteButton','useCRUDController','message','LucideIcon','convertResponsesToFormColumnMap','getValueByCode'] },
  { source: 'name_2',  target: 'ot.jsx', imports: ['Button','Input','Textarea','toast','Label','CrmContainerTitle1_1','CrmCategoryMenu1_1','CrmSelect2','CrmFileUpload1','CrmChart1','AIGenerateButton','message','jsonToQueryString','useCRUDController','generateComponentsOutput','applyResponsiveLayout','LucideIcon'] },
  { source: 'name_3',  target: 'ot.jsx', imports: ['Row','Col','message','Button','jsonToQueryString','useCRUDController','Spin','getClassifyStructureTypeDataLanguage','transformFormColumnDataToFiveWData','transformFiveWDataToFormColumnData','transformFormColumnDataToResponseFormValueData','TempDataProvider'] },
  { source: 'name_4',  target: 'ot.jsx', imports: ['Row','Col','LucideIcon','Button','Form','DeleteButton','message','useCRUDController','generateShadesFromHex'] },
  { source: 'name_7',  target: 'ot.jsx', imports: ['useProTableOt','Row','Col','LucideIcon','message','Button','useCRUDController','Spin','ProTableOt','setParamsFilter','Typography','FormStatic5'] },
  { source: 'name_10', target: 'ot.jsx', imports: ['LucideIcon','Button','message','useCRUDController','Name1'] },
  { source: 'name_11', target: 'ot.jsx', imports: ['Button','Modal','Tabs','Row','Col','Badge','ProTableOt','useProTableOt','useCRUDController','setParamsFilter','convertResponsesToFormColumnMap','convertCanvasToResponseData','message','updateValueByCode','LucideIcon','FormStatic5','BaseTreeSelector','BaseSelectBox','BaseImgCardView','BaseStatsCardTable','getValueByCode'] },
  { source: 'name_12', target: 'ot.jsx', imports: ['ProTableOt','useProTableOt','Button','Badge','Modal','Form','Input','Select','Row','Col','LucideIcon','message','useCRUDController'] },
  { source: 'name_13', target: 'ot.jsx', imports: ['ProTableOt','useProTableOt','Button','Badge','Modal','Form','Input','Select','Tabs','Row','Col','LucideIcon','message','useCRUDController'] },
  { source: 'name_14', target: 'ot.jsx', imports: ['Form','Input','Select','Button','Tabs','Row','Col','LucideIcon','message'] },
  { source: 'name_15', target: 'ot.jsx', imports: ['ProTableOt','useProTableOt','Button','Badge','Modal','Form','Input','Select','Row','Col','LucideIcon','message','useCRUDController','Tabs'] },
  { source: 'name_16', target: 'ot.jsx', imports: ['Row','Col','Button','Tabs','LucideIcon','ProTableOt','useProTableOt','PieDonutChart','ColorLabeledStatList'] },
  { source: 'name_17', target: 'ot.jsx', imports: ['Row','Col','Button','Tabs','LucideIcon','ProTableOt','useProTableOt','ChartStackedCategoryBars','ColorLabeledStatList'] },
  { source: 'name_18', target: 'ot.jsx', imports: ['ProTableOt','useProTableOt','Button','Badge','Modal','Form','Input','Select','Row','Col','LucideIcon','message','useCRUDController','Tabs','Typography'] },
  { source: 'name_19', target: 'ot.jsx', imports: ['ProTableOt','useProTableOt','Button','Badge','Modal','LucideIcon','message','Typography'] },
  { source: 'name_20', target: 'ot.jsx', imports: ['Button','Badge','Modal','LucideIcon','message'] },
  { source: 'name_21', target: 'ot.jsx', imports: ['Button','Badge','Modal','LucideIcon','message'] },
  { source: 'name_22', target: 'ot.jsx', imports: ['Button','Modal','LucideIcon','message'] },
  { source: 'name_23', target: 'ot.jsx', imports: ['ProTableOt','useProTableOt','Button','Badge','Modal','Form','Row','Col','LucideIcon','message'] },
  { source: 'name_24', target: 'ot.jsx', imports: ['Button','Badge','Modal','Form','LucideIcon','message'] },
  { source: 'name_25', target: 'ot.jsx', imports: ['Button','Badge','Modal','LucideIcon','message'] },
  { source: 'name_26', target: 'ot.jsx', imports: ['Button','Badge','Modal','LucideIcon','message'] },
  { source: 'name_27', target: 'ot.jsx', imports: ['Button','Badge','Modal','Form','LucideIcon','message'] },
  { source: 'name_28', target: 'ot.jsx', imports: ['Button','Badge','Modal','LucideIcon','message'] },
  { source: 'name_29', target: 'ot.jsx', imports: ['ProTableOt','useProTableOt','Button','Badge','Modal','Form','LucideIcon','message'] },
  { source: 'name_30', target: 'ot.jsx', imports: ['Button','Badge','LucideIcon'] },
  { source: 'name_31', target: 'ot.jsx', imports: ['Button','Badge','Modal','LucideIcon','message'] },
  { source: 'name_32', target: 'ot.jsx', imports: ['Button','Badge','Modal','LucideIcon'] },
  { source: 'name_33', target: 'ot.jsx', imports: ['Button','Badge','Modal','LucideIcon','message'] },
  { source: 'name_34', target: 'ot.jsx', imports: ['Button','Badge','Modal','LucideIcon'] },
  { source: 'name_35', target: 'ot.jsx', imports: ['Button','Modal','LucideIcon','message'] },
  { source: 'name_36', target: 'ot.jsx', imports: ['Button','Badge','Modal','LucideIcon','message'] },
  // ── card.jsx 引用 (每頁明確列出引用項目) ──────────────────────────────────────
  { source: 'name_16', target: 'card.jsx', imports: ['Card','CardContent','CardHeader','CardTitle'] },
  { source: 'name_17', target: 'card.jsx', imports: ['Card','CardContent','CardHeader','CardTitle'] },
  { source: 'name_18', target: 'card.jsx', imports: ['Card','CardContent','CardHeader','CardTitle'] },
  { source: 'name_19', target: 'card.jsx', imports: ['Card','CardContent'] },
  { source: 'name_20', target: 'card.jsx', imports: ['Card','CardContent'] },
  { source: 'name_21', target: 'card.jsx', imports: ['Card','CardContent'] },
  { source: 'name_22', target: 'card.jsx', imports: ['Card','CardContent'] },
  { source: 'name_23', target: 'card.jsx', imports: ['Card','CardContent'] },
  { source: 'name_24', target: 'card.jsx', imports: ['Card','CardContent'] },
  { source: 'name_25', target: 'card.jsx', imports: ['Card','CardContent'] },
  { source: 'name_26', target: 'card.jsx', imports: ['Card','CardContent'] },
  { source: 'name_27', target: 'card.jsx', imports: ['Card','CardContent'] },
  { source: 'name_28', target: 'card.jsx', imports: ['Card','CardContent'] },
  { source: 'name_29', target: 'card.jsx', imports: ['Card','CardContent'] },
  { source: 'name_30', target: 'card.jsx', imports: ['Card','CardContent'] },
  { source: 'name_31', target: 'card.jsx', imports: ['Card','CardContent'] },
  { source: 'name_32', target: 'card.jsx', imports: ['Card','CardContent'] },
  { source: 'name_33', target: 'card.jsx', imports: ['Card','CardContent'] },
  { source: 'name_34', target: 'card.jsx', imports: ['Card','CardContent'] },
  { source: 'name_35', target: 'card.jsx', imports: ['Card','CardContent'] },
  { source: 'name_36', target: 'card.jsx', imports: ['Card','CardContent'] },
  // ── 特殊外部套件 ──────────────────────────────────────────────────────────────
  { source: 'name_24', target: 'dnd_kit',          imports: ['DndContext','DragOverlay','closestCorners','PointerSensor','SortableContext','useSortable','arrayMove','CSS'] },
  { source: 'name_25', target: 'gantt_task_react', imports: ['Gantt','ViewMode'] },
  // ── name_1 特有依賴 ───────────────────────────────────────────────────────────
  { source: 'name_1', target: 'base_stats_card_header' },
  { source: 'name_1', target: 'base_card_view' },
  { source: 'name_1', target: 'base_list_view' },
  // ── name_4 特有依賴 ───────────────────────────────────────────────────────────
  { source: 'name_4', target: 'crm_dashboard' },
  { source: 'name_4', target: 'react_router_dom' },
  { source: 'name_4', target: 'dayjs' },
  // ── name_6 特有依賴 (name_6 不引用 ot.jsx) ───────────────────────────────────
  { source: 'name_6', target: 'base_input_storage' },
  // ── name_7 特有依賴 ───────────────────────────────────────────────────────────
  { source: 'name_7', target: 'base_canvas_edit_2' },
  { source: 'name_7', target: 'scroll_area' },
  { source: 'name_7', target: 'react_router_dom' },
  { source: 'name_7', target: 'dayjs' },
  // ── name_8 特有依賴 (name_8 不引用 ot.jsx) ───────────────────────────────────
  { source: 'name_8', target: 'base_doc_cre_canvas' },
  // ── name_9 特有依賴 (name_9 不引用 ot.jsx) ───────────────────────────────────
  { source: 'name_9', target: 'base_stats_card_header' },
  // ── name_10 特有依賴 ──────────────────────────────────────────────────────────
  { source: 'name_10', target: 'payment_component' },
  // ── name_11 特有依賴 ──────────────────────────────────────────────────────────
  { source: 'name_11', target: 'base_stats_card_header' },
  { source: 'name_11', target: 'base_calender' },
  { source: 'name_11', target: 'payment_component' },
  { source: 'name_11', target: 'dayjs' },
  // ── Component → Component ─────────────────────────────────────────────────────
  { source: 'base_canvas_edit_2',  target: 'form_static_5' },
  { source: 'base_doc_cre_canvas', target: 'base_canvas_edit_2' },
  { source: 'crm_dashboard',       target: 'base_stats_card_header' },
  { source: 'crm_dashboard',       target: 'base_card_view' },
];

// Pre-compute import counts
const IMPORT_COUNTS = {};
RAW_LINKS.forEach(l => {
  IMPORT_COUNTS[l.target] = (IMPORT_COUNTS[l.target] || 0) + 1;
});

// Enrich nodes with import counts
const GRAPH_NODES = RAW_NODES.map(n => ({ ...n, importCount: IMPORT_COUNTS[n.id] || 0 }));
const GRAPH_LINKS = RAW_LINKS.map(l => ({ ...l }));

// ── helpers ────────────────────────────────────────────────────────────────────
const getRadius = (node) => {
  const base = NODE_TYPE_META[node.type]?.baseR ?? 10;
  return base + Math.sqrt(node.importCount) * 2.4;
};

const BASE_ROUTE = '/utility/document';

// ── Detail Panel ───────────────────────────────────────────────────────────────
const DetailPanel = ({ node, onClose }) => {
  const navigate = useNavigate();
  if (!node) return null;
  const meta = NODE_TYPE_META[node.type] || NODE_TYPE_META.external;
  const importedBy = GRAPH_LINKS
    .filter(l => (l.target?.id ?? l.target) === node.id)
    .map(l => {
      const srcId = l.source?.id ?? l.source;
      return GRAPH_NODES.find(n => n.id === srcId);
    })
    .filter(Boolean);
  // depLinks: 此節點引用哪些依賴，以及每個依賴具體引用的 export 項目
  const depLinks = GRAPH_LINKS
    .filter(l => (l.source?.id ?? l.source) === node.id)
    .map(l => {
      const tgtId = l.target?.id ?? l.target;
      const targetNode = GRAPH_NODES.find(n => n.id === tgtId);
      return { node: targetNode, items: l.imports || [] };
    })
    .filter(d => d.node);

  return (
    <div className="absolute top-4 right-4 w-80 bg-white/95 backdrop-blur-sm rounded-2xl shadow-2xl border border-gray-200 overflow-hidden z-20 animate-in slide-in-from-right-4 duration-200">
      {/* Header */}
      <div className="px-5 py-4 border-b border-gray-100" style={{ background: `linear-gradient(135deg, ${meta.color}15, ${meta.color}05)` }}>
        <div className="flex items-start justify-between">
          <div className="flex items-center gap-2">
            <div className="w-9 h-9 rounded-xl flex items-center justify-center" style={{ background: `${meta.color}20` }}>
              <LucideIcon
                name={node.type === 'page' ? 'Layout' : node.type === 'library' ? 'Layers' : node.type === 'external' ? 'Package' : 'Puzzle'}
                className="w-4 h-4"
                style={{ color: meta.color }}
              />
            </div>
            <div>
              <div className="font-bold text-sm text-gray-800">{node.label}</div>
              <div className="text-xs text-gray-400 font-mono">{node.file}</div>
            </div>
          </div>
          <button onClick={onClose} className="p-1 rounded-lg hover:bg-gray-100 text-gray-400 hover:text-gray-600 transition-colors">
            <LucideIcon name="X" className="w-4 h-4" />
          </button>
        </div>
        <div className="flex items-center gap-2 mt-3">
          <span className="text-xs px-2 py-0.5 rounded-full font-medium border"
            style={{ background: `${meta.color}15`, color: meta.color, borderColor: `${meta.color}30` }}>
            {meta.zh}
          </span>
          {node.importCount > 0 && (
            <span className="text-xs px-2 py-0.5 rounded-full bg-amber-50 text-amber-700 border border-amber-200 font-semibold">
              被引用 {node.importCount} 次
            </span>
          )}
        </div>
      </div>

      <div className="p-5 space-y-4 max-h-96 overflow-y-auto">
        {/* Description */}
        <p className="text-sm text-gray-600 leading-relaxed">{node.desc}</p>

        {/* Imported by */}
        {importedBy.length > 0 && (
          <div>
            <div className="flex items-center gap-1.5 mb-2">
              <LucideIcon name="ArrowDownLeft" className="w-3.5 h-3.5 text-amber-500" />
              <span className="text-xs font-semibold text-gray-500">被以下引用（{importedBy.length}）</span>
            </div>
            <div className="flex flex-wrap gap-1.5">
              {importedBy.map(n => (
                <span key={n.id} className="text-xs px-2 py-0.5 rounded-lg bg-gray-100 text-gray-600 font-mono">{n.label}</span>
              ))}
            </div>
          </div>
        )}

        {/* Imports — 顯示每個依賴及其具體引用項目 */}
        {depLinks.length > 0 && (
          <div>
            <div className="flex items-center gap-1.5 mb-2">
              <LucideIcon name="ArrowUpRight" className="w-3.5 h-3.5 text-blue-500" />
              <span className="text-xs font-semibold text-gray-500">引用以下依賴（{depLinks.length}）</span>
            </div>
            <div className="space-y-2">
              {depLinks.map(({ node: n, items }) => (
                <div key={n.id} className="rounded-lg border border-gray-100 bg-gray-50 px-3 py-2">
                  <div className="text-xs font-semibold text-gray-700 font-mono mb-1">{n.label}</div>
                  {items.length > 0 && (
                    <div className="flex flex-wrap gap-1">
                      {items.map(item => (
                        <span key={item} className="text-xs px-1.5 py-0.5 rounded bg-blue-50 text-blue-600 font-mono border border-blue-100">{item}</span>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Demo button */}
        {node.demo && (
          <button
            onClick={() => navigate(`${BASE_ROUTE}/${node.demo}_demo`)}
            className="w-full flex items-center justify-center gap-2 py-2 rounded-xl text-sm font-semibold transition-all hover:opacity-90 active:scale-95"
            style={{ background: `linear-gradient(135deg, ${meta.color}, ${meta.color}cc)`, color: 'white' }}
          >
            <LucideIcon name="ExternalLink" className="w-4 h-4" />
            開啟 {node.label} Demo
          </button>
        )}
      </div>
    </div>
  );
};

// ── Legend ─────────────────────────────────────────────────────────────────────
const Legend = () => (
  <div className="absolute bottom-4 left-4 bg-black/60 backdrop-blur-sm rounded-xl px-4 py-3 flex items-center gap-5 z-10">
    {Object.entries(NODE_TYPE_META).map(([type, meta]) => (
      <div key={type} className="flex items-center gap-2">
        <div className="w-3 h-3 rounded-full flex-shrink-0" style={{ background: meta.color, boxShadow: `0 0 6px ${meta.color}` }} />
        <span className="text-xs text-gray-300 font-medium">{meta.zh}</span>
      </div>
    ))}
    <div className="w-px h-4 bg-white/20" />
    <span className="text-xs text-gray-400">節點大小 = 被引用次數</span>
  </div>
);

// ── Stat Bar ──────────────────────────────────────────────────────────────────
const StatBar = ({ onSearch, search }) => {
  const pageCount = GRAPH_NODES.filter(n => n.type === 'page').length;
  const compCount = GRAPH_NODES.filter(n => n.type === 'component').length;
  const libCount  = GRAPH_NODES.filter(n => n.type === 'library').length;
  const extCount  = GRAPH_NODES.filter(n => n.type === 'external').length;
  return (
    <div className="absolute top-4 left-4 flex items-center gap-3 z-10">
      <div className="bg-black/60 backdrop-blur-sm rounded-xl px-4 py-2 flex items-center gap-4">
        {[
          { label: 'Pages',     value: pageCount, color: '#6366f1' },
          { label: 'Components',value: compCount,  color: '#3b82f6' },
          { label: 'Libraries', value: libCount,   color: '#a855f7' },
          { label: 'External',  value: extCount,   color: '#64748b' },
          { label: 'Links',     value: GRAPH_LINKS.length, color: '#94a3b8' },
        ].map(s => (
          <div key={s.label} className="flex items-center gap-1.5">
            <span className="text-lg font-bold" style={{ color: s.color }}>{s.value}</span>
            <span className="text-xs text-gray-400">{s.label}</span>
          </div>
        ))}
      </div>
      <div className="bg-black/60 backdrop-blur-sm rounded-xl px-3 py-2 flex items-center gap-2">
        <LucideIcon name="Search" className="w-3.5 h-3.5 text-gray-400" />
        <input
          value={search}
          onChange={e => onSearch(e.target.value)}
          placeholder="搜尋節點..."
          className="bg-transparent text-sm text-white placeholder-gray-500 outline-none w-28"
        />
        {search && (
          <button onClick={() => onSearch('')} className="text-gray-500 hover:text-white">
            <LucideIcon name="X" className="w-3 h-3" />
          </button>
        )}
      </div>
    </div>
  );
};

// ── Main Graph Component ───────────────────────────────────────────────────────
const DependencyGraph = () => {
  const svgRef    = useRef();
  const gRef      = useRef();
  const simRef    = useRef();
  const [selected, setSelected] = useState(null);
  const [search, setSearch]     = useState('');

  const handleNodeClick = useCallback((node) => {
    setSelected(prev => prev?.id === node.id ? null : node);
  }, []);

  useEffect(() => {
    const container = svgRef.current?.parentElement;
    if (!container) return;

    const W = container.clientWidth;
    const H = 620;

    const svg = d3.select(svgRef.current)
      .attr('width',  W)
      .attr('height', H)
      .style('background', 'radial-gradient(ellipse at 50% 40%, #1e1b4b 0%, #0f0f23 55%, #000000 100%)');

    svg.selectAll('*').remove();

    // ── Defs ────────────────────────────────────────────────────────────────
    const defs = svg.append('defs');

    // Star field filter (subtle)
    const noise = defs.append('filter').attr('id', 'noise');
    noise.append('feTurbulence').attr('type','fractalNoise').attr('baseFrequency','0.9').attr('numOctaves','4').attr('stitchTiles','stitch');
    noise.append('feColorMatrix').attr('type','saturate').attr('values','0');
    noise.append('feBlend').attr('in','SourceGraphic').attr('in2','SourceGraphic').attr('mode','screen').attr('result','blend');
    noise.append('feComposite').attr('in','blend').attr('in2','SourceGraphic').attr('operator','in');

    // Glow filter
    const glow = defs.append('filter').attr('id','glow').attr('x','-50%').attr('y','-50%').attr('width','200%').attr('height','200%');
    glow.append('feGaussianBlur').attr('stdDeviation','3').attr('result','blur');
    const feMerge = glow.append('feMerge');
    feMerge.append('feMergeNode').attr('in','blur');
    feMerge.append('feMergeNode').attr('in','SourceGraphic');

    // Strong glow (for selected)
    const glowStrong = defs.append('filter').attr('id','glow-strong').attr('x','-80%').attr('y','-80%').attr('width','260%').attr('height','260%');
    glowStrong.append('feGaussianBlur').attr('stdDeviation','8').attr('result','blur');
    const feMerge2 = glowStrong.append('feMerge');
    feMerge2.append('feMergeNode').attr('in','blur');
    feMerge2.append('feMergeNode').attr('in','SourceGraphic');

    // Node gradients
    GRAPH_NODES.forEach(node => {
      const meta = NODE_TYPE_META[node.type] || NODE_TYPE_META.external;
      const grad = defs.append('radialGradient')
        .attr('id', `grad-${node.id.replace(/[^a-zA-Z0-9]/g, '_')}`)
        .attr('cx','35%').attr('cy','35%').attr('r','65%');
      grad.append('stop').attr('offset','0%').attr('stop-color', lightenColor(meta.color, 60));
      grad.append('stop').attr('offset','60%').attr('stop-color', meta.color);
      grad.append('stop').attr('offset','100%').attr('stop-color', darkenColor(meta.color, 40));
    });

    // ── Zoom ────────────────────────────────────────────────────────────────
    const zoom = d3.zoom().scaleExtent([0.2, 4]).on('zoom', e => {
      gRef.current && d3.select(gRef.current).attr('transform', e.transform);
    });
    svg.call(zoom);

    // ── Container group ─────────────────────────────────────────────────────
    const g = svg.append('g').attr('id', 'graph-root');
    gRef.current = g.node();

    // Deep clone nodes/links for D3 (it mutates them)
    const nodes = GRAPH_NODES.map(d => ({ ...d }));
    const nodeMap = Object.fromEntries(nodes.map(n => [n.id, n]));
    const links  = GRAPH_LINKS.map(d => ({
      source: nodeMap[d.source] || d.source,
      target: nodeMap[d.target] || d.target,
    })).filter(l => l.source && l.target);

    // ── Simulation ──────────────────────────────────────────────────────────
    const sim = d3.forceSimulation(nodes)
      .force('link',      d3.forceLink(links).id(d => d.id).distance(d => {
        // Pages farther from libraries
        const sType = (d.source.type || '');
        const tType = (d.target.type || '');
        if (sType === 'page' && tType === 'library')   return 120;
        if (sType === 'page' && tType === 'component') return 100;
        return 80;
      }).strength(0.4))
      .force('charge',    d3.forceManyBody().strength(d => d.type === 'page' ? -350 : -180))
      .force('center',    d3.forceCenter(W / 2, H / 2))
      .force('collision', d3.forceCollide().radius(d => getRadius(d) + 12))
      .alphaDecay(0.025);
    simRef.current = sim;

    // ── Links ───────────────────────────────────────────────────────────────
    const linkG = g.append('g').attr('class', 'links');
    const link = linkG.selectAll('line')
      .data(links)
      .join('line')
      .attr('stroke', d => {
        const tType = d.target.type || 'component';
        return NODE_TYPE_META[tType]?.color ?? '#475569';
      })
      .attr('stroke-opacity', 0.25)
      .attr('stroke-width', 1.2);

    // ── Nodes ───────────────────────────────────────────────────────────────
    const nodeG = g.append('g').attr('class', 'nodes');
    const nodeGroup = nodeG.selectAll('g')
      .data(nodes)
      .join('g')
      .attr('class', 'node-group')
      .style('cursor', 'pointer')
      .call(d3.drag()
        .on('start', (event, d) => { if (!event.active) sim.alphaTarget(0.3).restart(); d.fx = d.x; d.fy = d.y; })
        .on('drag',  (event, d) => { d.fx = event.x; d.fy = event.y; })
        .on('end',   (event, d) => { if (!event.active) sim.alphaTarget(0); d.fx = null; d.fy = null; })
      )
      .on('click', (event, d) => { event.stopPropagation(); handleNodeClick(d); });

    // Outer glow ring (visible when importCount > 0)
    nodeGroup.append('circle')
      .attr('r', d => getRadius(d) + 4)
      .attr('fill', 'none')
      .attr('stroke', d => NODE_TYPE_META[d.type]?.color ?? '#475569')
      .attr('stroke-width', d => d.importCount > 0 ? 1 : 0)
      .attr('stroke-opacity', 0.3)
      .attr('class', 'glow-ring');

    // Main circle
    nodeGroup.append('circle')
      .attr('r', d => getRadius(d))
      .attr('fill', d => `url(#grad-${d.id.replace(/[^a-zA-Z0-9]/g, '_')})`)
      .attr('filter', 'url(#glow)')
      .attr('class', 'main-circle');

    // Label
    nodeGroup.append('text')
      .text(d => d.label)
      .attr('text-anchor', 'middle')
      .attr('dy', d => getRadius(d) + 13)
      .attr('font-size', '10px')
      .attr('font-weight', '600')
      .attr('fill', d => NODE_TYPE_META[d.type]?.labelColor ?? '#94a3b8')
      .attr('font-family', 'system-ui, sans-serif')
      .style('pointer-events', 'none')
      .style('user-select', 'none');

    // Import count badge
    nodeGroup.filter(d => d.importCount > 0)
      .append('text')
      .text(d => d.importCount)
      .attr('text-anchor', 'middle')
      .attr('dy', '0.35em')
      .attr('font-size', d => getRadius(d) > 14 ? '10px' : '8px')
      .attr('font-weight', '800')
      .attr('fill', 'white')
      .style('pointer-events', 'none')
      .style('user-select', 'none');

    // ── Click outside to deselect ────────────────────────────────────────────
    svg.on('click', () => setSelected(null));

    // ── Tick ────────────────────────────────────────────────────────────────
    sim.on('tick', () => {
      link
        .attr('x1', d => d.source.x).attr('y1', d => d.source.y)
        .attr('x2', d => d.target.x).attr('y2', d => d.target.y);
      nodeGroup.attr('transform', d => `translate(${d.x},${d.y})`);
    });

    // ── Initial zoom to fit ──────────────────────────────────────────────────
    setTimeout(() => {
      svg.transition().duration(800).call(
        zoom.transform,
        d3.zoomIdentity.translate(W * 0.05, H * 0.05).scale(0.9)
      );
    }, 1200);

    return () => {
      sim.stop();
    };
  }, []); // eslint-disable-line

  // Highlight selected node + dim others
  useEffect(() => {
    if (!gRef.current) return;
    const g = d3.select(gRef.current);

    if (!selected) {
      g.selectAll('.node-group .main-circle').attr('opacity', 1).attr('filter', 'url(#glow)');
      g.selectAll('.node-group text').attr('opacity', 1);
      g.selectAll('.links line').attr('stroke-opacity', 0.25);
      return;
    }

    const connectedIds = new Set([selected.id]);
    GRAPH_LINKS.forEach(l => {
      const sId = l.source?.id ?? l.source;
      const tId = l.target?.id ?? l.target;
      if (sId === selected.id) connectedIds.add(tId);
      if (tId === selected.id) connectedIds.add(sId);
    });

    g.selectAll('.node-group').each(function(d) {
      const el = d3.select(this);
      const isConnected = connectedIds.has(d.id);
      el.select('.main-circle')
        .attr('opacity', isConnected ? 1 : 0.2)
        .attr('filter', d.id === selected.id ? 'url(#glow-strong)' : isConnected ? 'url(#glow)' : 'none');
      el.selectAll('text').attr('opacity', isConnected ? 1 : 0.15);
    });

    g.selectAll('.links line').attr('stroke-opacity', d => {
      const sId = d.source?.id ?? d.source;
      const tId = d.target?.id ?? d.target;
      return (sId === selected.id || tId === selected.id) ? 0.8 : 0.05;
    }).attr('stroke-width', d => {
      const sId = d.source?.id ?? d.source;
      const tId = d.target?.id ?? d.target;
      return (sId === selected.id || tId === selected.id) ? 2.5 : 1.2;
    });
  }, [selected]);

  // Search highlight
  useEffect(() => {
    if (!gRef.current) return;
    if (!search) return;
    const q = search.toLowerCase();
    const g = d3.select(gRef.current);
    g.selectAll('.node-group').each(function(d) {
      const match = d.id.toLowerCase().includes(q) || d.label.toLowerCase().includes(q);
      d3.select(this).select('.main-circle').attr('opacity', match ? 1 : 0.15);
      d3.select(this).selectAll('text').attr('opacity', match ? 1 : 0.1);
    });
    g.selectAll('.links line').attr('stroke-opacity', 0.05);
  }, [search]);

  return (
    <div className="relative rounded-2xl overflow-hidden border border-indigo-900/30 shadow-2xl" style={{ height: 620 }}>
      <svg ref={svgRef} style={{ display: 'block', width: '100%', height: '100%' }} />

      <StatBar search={search} onSearch={(v) => { setSearch(v); if (!v) setSelected(null); }} />
      <Legend />

      <DetailPanel node={selected} onClose={() => setSelected(null)} />

      {/* Hint */}
      {!selected && (
        <div className="absolute bottom-14 right-4 text-xs text-gray-500 bg-black/40 rounded-lg px-3 py-1.5 flex items-center gap-1.5">
          <LucideIcon name="MousePointer2" className="w-3 h-3" />
          點擊節點查看詳情 · 拖曳移動 · 滾輪縮放
        </div>
      )}
    </div>
  );
};

// ── Color helpers ──────────────────────────────────────────────────────────────
function lightenColor(hex, amount) {
  const num = parseInt(hex.replace('#', ''), 16);
  const r = Math.min(255, (num >> 16) + amount);
  const g = Math.min(255, ((num >> 8) & 0xff) + amount);
  const b = Math.min(255, (num & 0xff) + amount);
  return `rgb(${r},${g},${b})`;
}
function darkenColor(hex, amount) {
  const num = parseInt(hex.replace('#', ''), 16);
  const r = Math.max(0, (num >> 16) - amount);
  const g = Math.max(0, ((num >> 8) & 0xff) - amount);
  const b = Math.max(0, (num & 0xff) - amount);
  return `rgb(${r},${g},${b})`;
}

// ── Export (with usage-count stats table) ─────────────────────────────────────
const UsageRankTable = () => {
  const ranked = [...GRAPH_NODES]
    .filter(n => n.importCount > 0)
    .sort((a, b) => b.importCount - a.importCount);

  return (
    <div className="mt-6 rounded-2xl border border-gray-200 overflow-hidden">
      <div className="px-5 py-3 bg-gray-50 border-b border-gray-200 flex items-center gap-2">
        <LucideIcon name="BarChart3" className="w-4 h-4 text-indigo-500" />
        <span className="text-sm font-semibold text-gray-700">元件被引用次數排行</span>
        <span className="text-xs text-gray-400 ml-auto">共 {ranked.length} 個元件有被引用</span>
      </div>
      <div className="divide-y divide-gray-100">
        {ranked.map((node, idx) => {
          const meta = NODE_TYPE_META[node.type] || NODE_TYPE_META.external;
          const pct = (node.importCount / ranked[0].importCount) * 100;
          return (
            <div key={node.id} className="flex items-center gap-4 px-5 py-3 hover:bg-gray-50 transition-colors">
              <span className={`w-6 text-center text-xs font-bold ${idx < 3 ? 'text-amber-500' : 'text-gray-400'}`}>
                #{idx + 1}
              </span>
              <div className="flex items-center gap-2 w-44 flex-shrink-0">
                <div className="w-2.5 h-2.5 rounded-full flex-shrink-0" style={{ background: meta.color }} />
                <span className="text-sm font-mono text-gray-700 truncate">{node.label}</span>
              </div>
              <span className="text-xs px-1.5 py-0.5 rounded border flex-shrink-0"
                style={{ background: `${meta.color}10`, color: meta.color, borderColor: `${meta.color}25` }}>
                {meta.zh}
              </span>
              <div className="flex-1 flex items-center gap-3">
                <div className="flex-1 bg-gray-100 rounded-full h-2 overflow-hidden">
                  <div className="h-full rounded-full transition-all" style={{ width: `${pct}%`, background: `linear-gradient(90deg, ${meta.color}, ${meta.color}99)` }} />
                </div>
                <span className="text-sm font-bold w-8 text-right" style={{ color: meta.color }}>{node.importCount}</span>
                <span className="text-xs text-gray-400 w-8">次</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

const NameDemoDependencyGraph = () => {
  const [showGraph, setShowGraph] = useState(true);

  return (
    <div className="mt-8 px-8 pb-12 max-w-5xl mx-auto">
      <div className="flex items-center gap-3 mb-5">
        <div className="w-8 h-8 rounded-lg bg-indigo-600 flex items-center justify-center">
          <LucideIcon name="Network" className="w-4 h-4 text-white" />
        </div>
        <div>
          <h2 className="text-lg font-bold text-gray-900">頁面 × 元件關聯圖</h2>
          <p className="text-xs text-gray-400 mt-0.5">以 Force-Directed Graph 呈現各頁面對 UI 元件的引用關係</p>
        </div>
        <button
          onClick={() => setShowGraph(v => !v)}
          className="ml-auto flex items-center gap-1.5 px-3 py-1.5 rounded-lg border border-gray-200 text-xs text-gray-600 hover:bg-gray-50 transition-colors"
        >
          <LucideIcon name={showGraph ? 'EyeOff' : 'Eye'} className="w-3.5 h-3.5" />
          {showGraph ? '收合圖形' : '展開圖形'}
        </button>
      </div>

      {showGraph && <DependencyGraph />}

      <UsageRankTable />
    </div>
  );
};

export default NameDemoDependencyGraph;
